// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsPageStyles } from "@vanmeter/Overrides/Pages/ProductDetailsPage";
import { layoutContainer, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productDetailsPageStyles.skeletonContainer = {
    css: css`
        margin: 16px 0 64px 0;
        ${layoutContainer}
    `,
};

productDetailsPageStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 508px) minmax(0, 1fr) minmax(0, 374px);
        ${xScreen("lte", "lg")} {
            grid-template-columns: minmax(0, 430px) minmax(0, 1fr) minmax(0, 317px);
        }
        gap: 22px;
        grid-column: 1/3;
        margin-bottom: 32px;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 20px;
            .md-title {
                min-height: 36px;
            }
            .md-subtitle {
                min-height: 46px;
            }
            .md-image {
                width: 100%;
                aspect-ratio: 1;
                min-height: unset;
            }
            .md-description {
                min-height: 125px;
            }
        }
        ${xScreen("gt", "lg")} {
            .lg-image {
                width: 100%;
                aspect-ratio: 1;
                min-height: unset;
            }
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
        }
    `,
};

productDetailsPageStyles.imageSkeleton = {
    css: css`
        grid-row: 1 / 3;
        ${xScreen("lte", "md")} {
            grid-row: 1 / 2;
        }
    `,
};

productDetailsPageStyles.infoSkeleton = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 2;
        }
    `,
};

productDetailsPageStyles.actionsSkeleton = {
    css: css`
        ${xScreen("lte", "md")} {
            grid-row: 1 / 3;
            grid-column: 2 / 3;
        }
        ${xScreen("lte", "sm")} {
            grid-row: 3 / 4;
            grid-column: 1 / 2;
        }
    `,
};
